<template>
    <div class="row">
        <div class="col-12 col-md-8 ">
            <div class="card mb-3">
                <div class="row no-gutters">
                    <div class="col-2">
                        <div class="card-body">
                            <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                    <div class="col-10">
                        <div class="card-body pb-0">
                            <p class="mb-0 text-lg fw-bold">{{ $t('Endre passord') }}</p>
                        </div>
                    </div>
                    <div class="col-12 offset-sm-2 col-sm-10">
                        <div class="card-body pt-0">
                            <div class="row mb-2">
                                <div class="col-5 col-md-7">
                                    <p class="fw-bold mb-0 text-sm">{{ $t('Nåværende passord') }}</p>
                                </div>
                                <div class="text-end col-7 col-md-5">
                                    <input maxlength="100" type="password" v-model="current_password" class="form-control form-control-sm text-end" :placeholder="$t('Ditt nåværende passord')">
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5 col-md-7">
                                    <p class="fw-bold mb-0 text-sm">{{ $t('Passord') }}</p>
                                </div>
                                <div class="text-end col-7 col-md-5">
                                    <input maxlength="100" type="password" v-model="password" class="form-control form-control-sm text-end" :placeholder="$t('Passord')">
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5 col-md-7">
                                    <p class="fw-bold mb-0 text-sm">{{ $t('Bekreft passord') }}</p>
                                </div>
                                <div class="text-end col-7 col-md-5">
                                    <input maxlength="100" type="password" v-model="password_confirm" class="form-control form-control-sm text-end" :placeholder="$t('Bekreft passord')">
                                </div>
                            </div>

                            <div class="text-end">
                                <span class="btn btn-success btn-sm fw-bold px-3 py-2" @click="save" :class="{'disabled':isSaving}">
                                    {{ $t('Oppdater') }}
                                    <span v-if="isSaving" class="ml-2 fa fa-spinner fa-spin"></span>
                                </span>
                            </div>
                            <div>
                                <div class="alert alert-danger p-2 text-sm mt-2 text-center" v-if="error">{{error}}</div>
                                <div class="alert alert-success p-2 text-sm mt-2 text-center" v-if="success">{{ success }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import Api from '../../api/Profile'

const current_password = ref('')
const password = ref('')
const password_confirm = ref('')
const error = ref('')
const success = ref('')
const isSaving = ref(false)

const save = () => {
    if (current_password.value.length < 5) {
        error.value = $t('Du må skrive inn ditt nåværende passord for å bytte passord')
        return
    }

    if (password.value.length < 5 || password_confirm.value.length < 5) {
        error.value = $t('Passordet er for kort. Må inneholde minst 5 karakterer')
        return
    }

    success.value = ''
    error.value = ''
    isSaving.value = true
    Api.UpdatePassword({
        password: password.value,
        current_password: current_password.value,
        password_confirm: password_confirm.value,
    }).then(res => {
        isSaving.value = false
        if (!res.success) {
            error.value = res.message
            return
        }
        password.value = ''
        current_password.value = ''
        password_confirm.value = ''
        success.value = $t('Passordet ble oppdatert')
    }).catch(e => {
        isSaving.value = false
        error.value = $t('Noe gikk galt. Prøv igjen senere.')
    })
}
</script>